// LoadingContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isAPILoading, setIsAPILoading] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isAPILoading) {
        e.preventDefault();
        e.returnValue = 'An API request is in progress. Are you sure you want to leave?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isAPILoading]);

  return (
    <LoadingContext.Provider value={{ isAPILoading, setIsAPILoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
